<template>
  <div class="policy-progress" :class="{ 'is-unavailable': percent == null, 'has-embedded-values': showValues }">
    <div class="policy-progress-track" :role="percent != null ? 'progressbar' : undefined" :aria-label="label + (percent == null ? '：' + text : '进度')" :aria-valuemin="percent != null ? 0 : undefined" :aria-valuemax="percent != null ? 100 : undefined" :aria-valuenow="percent != null ? Math.min(100, percent) : undefined" :aria-valuetext="percent != null ? ariaText : undefined" :title="ariaText">
      <span v-if="percent != null" class="policy-progress-fill" :style="{ width: Math.min(100, percent) + '%', backgroundColor: color }" />
      <span v-if="showValues" class="policy-progress-values"><span>{{ display(value) }}</span><span v-if="hasTarget">/ {{ display(target) }}<template v-if="unit && !hideUnit"> {{ unit }}</template></span><span v-else-if="unit && !hideUnit">{{ unit }}</span></span>
      <span v-if="showValues" class="policy-progress-inside-text">{{ text }}</span>
    </div>
    <span v-if="!showValues" class="policy-progress-text">{{ text }}</span>
  </div>
</template>

<script>
import { policyDisplayNumber, policyNumber, policyProgress } from '../services/policyProgress'

export default {
  name: 'PolicyProgressBar',
  props: { value: {}, target: {}, label: { type: String, default: '指标' }, color: { type: String, default: '#2f86d4' }, unit: { type: String, default: '' }, budget: Boolean, showValues: Boolean, hideUnit: Boolean },
  computed: {
    percent () { return policyProgress(this.value, this.target) },
    hasTarget () { return policyNumber(this.target) != null },
    ariaText () { return '当前 ' + this.display(this.value) + (this.hasTarget ? ' / ' + this.display(this.target) : '') + (this.unit ? ' ' + this.unit : '') + '，' + this.text },
    text () {
      const goal = policyNumber(this.target)
      if (goal == null) return this.budget ? '未设预算' : '未设目标'
      if (goal === 0) return this.budget ? '预算为0' : '目标为0'
      if (goal < 0) return this.budget ? '预算无效' : '目标无效'
      return this.percent == null ? '暂无数据' : String(Math.round(this.percent * 10) / 10) + '%'
    }
  },
  methods: { display: policyDisplayNumber }
}
</script>
